import { WithChildren } from 'types/component';
import { useInterceptors } from './axios';

export const AxiosInterceptor = ({ children }: WithChildren) => {
  useInterceptors();

  return <>{children}</>;
};
